// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__jEzHx","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__PG1QB"};